import React from 'react';
import { motion } from 'framer-motion';
import ProjectCard from '../components/ProjectCard';

const podcastProjects = [
  {
    title: 'Podcast Series: "RANDM Thoughts"',
    description: 'A conversational podcast where we explore interesting ideas, unusual stories, and unexpected connections.',
    image: 'https://via.placeholder.com/600x400?text=RANDM+Thoughts',
    creator: 'Both' as const,
    tags: ['Conversation', 'Ideas', 'Weekly Series'],
    link: '#'
  },
  {
    title: 'Interview Series: "Creative Minds"',
    description: 'In-depth interviews with artists, musicians, writers, and other creatives about their process and inspirations.',
    image: 'https://via.placeholder.com/600x400?text=Creative+Minds',
    creator: 'Roscoe' as const,
    tags: ['Interviews', 'Creative Process', 'Artists'],
    link: '#'
  },
  {
    title: 'Documentary Podcast: "Hidden Stories"',
    description: 'Audio documentaries uncovering lesser-known historical events and the people behind them.',
    image: 'https://via.placeholder.com/600x400?text=Hidden+Stories',
    creator: 'Matthew' as const,
    tags: ['Documentary', 'History', 'Storytelling'],
    link: '#'
  },
  {
    title: 'Limited Series: "The Experiment"',
    description: 'A six-episode exploration of a single scientific experiment that changed our understanding of human behavior.',
    image: 'https://via.placeholder.com/600x400?text=The+Experiment',
    creator: 'Both' as const,
    tags: ['Science', 'Psychology', 'Limited Series'],
    link: '#'
  },
  {
    title: 'Audio Fiction: "The Parallel"',
    description: 'A fictional audio drama set in a parallel universe where small historical changes led to major differences.',
    image: 'https://via.placeholder.com/600x400?text=The+Parallel',
    creator: 'Matthew' as const,
    tags: ['Fiction', 'Drama', 'Alternate History'],
    link: '#'
  },
  {
    title: 'Sound Exploration: "Audio Journeys"',
    description: 'Immersive audio experiences capturing the soundscapes of different environments around the world.',
    image: 'https://via.placeholder.com/600x400?text=Audio+Journeys',
    creator: 'Roscoe' as const,
    tags: ['Sound Design', 'Field Recording', 'Immersive'],
    link: '#'
  }
];

const PodcastPage: React.FC = () => {
  return (
    <div>
      <motion.div 
        className="text-center max-w-3xl mx-auto mb-12"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-4xl font-bold mb-6">RANDM Podcast</h1>
        <p className="text-xl text-gray-600">
          Our audio explorations across different podcast formats. From conversational shows to documentary series,
          interviews to fiction, immersive soundscapes to topical discussions.
        </p>
      </motion.div>
      
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {podcastProjects.map((project, index) => (
          <motion.div
            key={project.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <ProjectCard {...project} />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default PodcastPage; 